"use strict";

const NOOP = () => {};
export { NOOP };
